import React from 'react'

const CalendarInputArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4.6"
      height="8.261"
      viewBox="0 0 4.6 8.261"
      {...props}
    >
      <path
        d="M236.328,281.64l3.424,3.393,3.423-3.393h0"
        transform="translate(285.533 -235.621) rotate(90)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </svg>
  )
}

export { CalendarInputArrow }
